const DrillStockInCategoryMap = {
  '1': '订单系统',
  '2': '其他库房',
  '3': '外来钻头',
  '4': '服务回收',
  '5': '退货入库',
}

const DrillStockOutCategoryMap = {
  '1': '调货出库',
  '2': '服务出库',
  '3': '修复出库',
  '4': '销售出库',
  '5': '损毁出库',
  '6': '报废出库',
}

const ItemStockInCategoryMap = {
  '1': '一般入库',
  '2': '特殊入库',
}

const ItemStockOutCategoryMap = {
  '1': '一般出库',
  '2': '特殊出库',
}

const DrillStageMap = {
  '1': '待发货',
  '2': '可维修',
  '3': '未使用',
  '4': '销售',
  '5': '损毁',
  '6': '报废',
  '7': '已发货',
}

const DrillTypeMap = {
  2: 'S钢体PDC',
  3: 'H复合钻头',
  4: 'M胎体PDC',
  5: 'B双心钻头',
  6: 'C取芯钻头',
  7: 'R牙轮钻头',
}

const DrillIsNewMap = {
  1: '新',
  2: '旧',
  3: '返新',
  4: '修复',
}

const BlockTypeMap = {
  1: 'Tdrill Mid East',
  2: 'Tdrill CIS',
  4: 'Tdrill China西南',
  5: 'Tdrill Asia',
  6: 'Tdrill Africa',
  7: 'Tdrill China西北',
  8: 'Tdrill China东北',
  9: 'Tdrill China陕北',
  10: 'Tdrill China其他',
  11: 'Tdrill 美国',
}

const DrillPackageType = {
  '1': '奥瑞拓',
  '2': '海纳',
  '3': '达坦',
  '4': '鼎鑫',
  '5': '其他',
}

const ReportUserLevelMap = {
  '1': '服务人员',
  '2': '大区',
  '3': '总部',
}

const ReportDrillStatusMap = {
  '1': '下钻',
  '2': '钻进',
  '3': '其他',
  '4': '起钻',
}

const ProjectDrillStatusMap = {
  1: '待钻',
  2: '在钻',
  3: '完钻',
}

const PurchaseOrderStatusMap = {
  1: '待入库',
  // 2: '待入库',
  3: '已入库',
  // 100: '已入库',
}

const PurchaseOrderLogMap = {
  1: '创建采购单',
  2: '完成到货质检',
  3: '完成入库',
  4: '完成发票结算',
}
const SaleOrderStatusMap = {
  1: '待发货',
  2: '待开票',
  100: '已完成',
}

const OutboundOrderStatusMap = {
  1: '待出库',
  2: '已出库',
}

const CommodityCategoryMap = [
  { id: 1, name: '复合片' },
  { id: 3, name: '牙轮' },
  { id: 4, name: '合金' },
  { id: 5, name: '钢件' },
  { id: 6, name: '焊材砂轮' },
  { id: 7, name: '包装箱' },
  { id: 8, name: '气体' },
  { id: 9, name: '检具' },
  { id: 10, name: '耗材' },
]

export { DrillStockInCategoryMap, DrillStageMap, DrillStockOutCategoryMap, DrillTypeMap, DrillIsNewMap, BlockTypeMap, DrillPackageType, ItemStockInCategoryMap, ItemStockOutCategoryMap, ReportUserLevelMap, ReportDrillStatusMap, ProjectDrillStatusMap, PurchaseOrderStatusMap, PurchaseOrderLogMap, SaleOrderStatusMap, CommodityCategoryMap, OutboundOrderStatusMap }
